import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../uicomponentcss";

export interface SwitchCSSStyle extends UIComponentCSSStyle
{

}

export class SwitchCSSStyleImpl extends UIComponentCSSStyleImpl implements SwitchCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:"60px",
            height:"36px"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/switch/switchcss.tsx